import { footerData, siteInfo } from '@/mocks/tanhua';

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-200/80">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-lg font-heading text-background-50 mb-3 whitespace-nowrap">
              {siteInfo.name}
            </h3>
            <p className="text-xs md:text-sm leading-relaxed text-background-300/80">
              {footerData.intro}
            </p>
          </div>

          {footerData.columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-medium text-background-100 mb-4 whitespace-nowrap">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-xs md:text-sm text-background-300/80 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-background-800/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-6">
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-background-300/60 hover:text-accent-400 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#hero" className="text-background-300/60 hover:text-accent-400 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#hero" className="text-background-300/60 hover:text-accent-400 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>

            <p className="text-xs text-background-400/80 whitespace-nowrap">
              &copy; 2026 {siteInfo.name} · 国产探花资源聚合平台
            </p>
          </div>

          <div className="text-center">
            <span className="text-xs text-background-500/60 font-medium whitespace-nowrap">
              {footerData.partners}
            </span>
            <div className="flex flex-wrap justify-center gap-3 mt-3">
              {['果冻传媒', '国产探花联盟', '探花资源网', '探花视频站', '探花爱好者社区'].map((name) => (
                <span
                  key={name}
                  className="text-xs text-background-500/40 whitespace-nowrap"
                >
                  {name}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}